<script setup lang="ts">
  import { useTemplateRef } from 'vue'
  import AgencyGroupModalAdd, {
    type ShowAddAgencyGroupModalParams
  } from '../modals/AgencyGroupModalAdd.vue'
  import AgencyModalAdd, {
    type ShowAddAgencyModalParams
  } from '../modals/AgencyModalAdd.vue'
  import AgencyGroupModalRemove, {
    type ShowRemoveAgencyGroupModalParams
  } from '../modals/AgencyGroupModalRemove.vue'
  import AgencyGroupModalChangeName, {
    type ShowChangeAgencyGroupNameModalParams
  } from '../modals/AgencyGroupModalChangeName.vue'
  import AgencyGroupModalMove, {
    type ShowMoveAgencyGroupModalParams
  } from '../modals/AgencyGroupModalMove.vue'
  import { agencyStructureModalsKey } from './agency-structure-modals'
  import { provide } from 'vue'

  const modalAddAgencyGroupRef = useTemplateRef('modalAddAgencyGroupRef')
  const modalAddAgencyRef = useTemplateRef('modalAddAgencyRef')
  const modalAgencyGroupRemoveRef = useTemplateRef('modalAgencyGroupRemoveRef')
  const modalAgencyGroupNameChangeRef = useTemplateRef(
    'modalAgencyGroupNameChangeRef'
  )
  const modalAgencyGroupMoveRef = useTemplateRef('modalAgencyGroupMoveRef')

  const agencyStructureModals = {
    showAddAgencyGroupModal: (params: ShowAddAgencyGroupModalParams) => {
      modalAddAgencyGroupRef.value?.showModal(params)
    },
    showAddAgencyModal: (params: ShowAddAgencyModalParams) => {
      modalAddAgencyRef.value?.showModal(params)
    },
    showRemoveAgencyGroupModal: (params: ShowRemoveAgencyGroupModalParams) => {
      modalAgencyGroupRemoveRef.value?.showModal(params)
    },
    showChangeAgencyGroupNameModal: (
      params: ShowChangeAgencyGroupNameModalParams
    ) => {
      modalAgencyGroupNameChangeRef.value?.showModal(params)
    },
    showMoveAgencyGroupModal: (params: ShowMoveAgencyGroupModalParams) => {
      modalAgencyGroupMoveRef.value?.showModal(params)
    }
  }

  provide(agencyStructureModalsKey, agencyStructureModals)

  defineExpose(agencyStructureModals)
</script>

<template>
  <slot />
  <AgencyGroupModalAdd ref="modalAddAgencyGroupRef" />
  <AgencyModalAdd ref="modalAddAgencyRef" />
  <AgencyGroupModalRemove ref="modalAgencyGroupRemoveRef" />
  <AgencyGroupModalChangeName ref="modalAgencyGroupNameChangeRef" />
  <AgencyGroupModalMove ref="modalAgencyGroupMoveRef" />
</template>
